var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "wpay-mypage"
  }, [_c('form', {
    ref: "form",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "action": _vm.url,
      "method": "post",
      "target": _vm.target
    }
  }, _vm._l(_vm.params, function (value, key) {
    return _c('input', {
      key: key,
      attrs: {
        "type": "hidden",
        "name": key
      },
      domProps: {
        "value": value
      }
    });
  }), 0), _c('v-btn', _vm._b({
    attrs: {
      "small": "",
      "outlined": "",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('v-icon', {
    attrs: {
      "small": "",
      "left": ""
    }
  }, [_vm._v("mdi-cog-outline")]), _vm._v(" KG이니시스 결제계좌 관리 ")], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }